var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _vm.ticketEvent && _vm.ticketEvent.visible
    ? _c("i", {
        staticClass: "el-icon-microphone ticket-event-visible-switch",
        attrs: { title: "这是一条公开回复,点击可修改为私密的" },
        on: {
          click: function($event) {
            return _vm.updateVisible(_vm.ticketEvent)
          }
        }
      })
    : _c("i", {
        staticClass: "el-icon-turn-off-microphone ticket-event-visible-switch",
        attrs: { title: "这是一条私密回复,对淘金客不可见,点击可修改为公开的" },
        on: {
          click: function($event) {
            return _vm.updateVisible(_vm.ticketEvent)
          }
        }
      })
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-5bc50f4a", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-5bc50f4a","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/ticket/TicketEventVisibleSwitch.vue
// module id = 1022
// module chunks = 75